<ion-header>
  <ion-toolbar class="thin-toolbar background-background" mode="ios">
    <frontend-header routeId="analytics"></frontend-header>
  </ion-toolbar>
</ion-header>

<ion-content [forceOverscroll]="false">
  <frontend-pull-refresh></frontend-pull-refresh>

  <div class="h-100 col-12 pt-3 pl-md-4 ng-scope">
    <div class="d-flex flex-nowrap align-items-end">
      <div class="form-group mr-2">
        <label for="analytics-start" class="control-label">Start date</label>
        <input class="form-control"
               id="analytics-start"
               placeholder="dd/mm/yyyy"
               name="startDate"
               [(ngModel)]="fromDate"
               [minDate]="dateOptions.minDate"
               [maxDate]="dateOptions.maxDate"
               ngbDatepicker
               container="body"
               #startDateDatepicker="ngbDatepicker"
               (click)="startDateDatepicker.toggle()">
      </div>
      <div class="form-group mr-2">
        <label for="analytics-end" class="control-label">End date</label>
        <input class="form-control"
               id="analytics-end"
               placeholder="dd/mm/yyyy"
               name="endDate"
               [minDate]="dateOptions.minDate"
               [maxDate]="dateOptions.maxDate"
               [(ngModel)]="toDate"
               ngbDatepicker
               container="body"
               #endDateDatepicker="ngbDatepicker"
               (click)="endDateDatepicker.toggle()">
      </div>
      <div class="form-group">
        <button [disabled]="formatDateToTimestamp(fromDate, 'from') > formatDateToTimestamp(toDate, 'to')" class="btn btn-info" (click)="updateAnalytics()">Update</button>
      </div>
    </div>

    <tablesready-statistics
      #statisticsComponent
      [fromDate]="fromDate"
      [toDate]="toDate"
      [labels]="labels"
      [size]="size"
      [statistics]="analytics?.statistics"
      [timezone]="timezone"
      [loadTodayStats]="loadTodayStats"
      [simpleDateToMoment]="simpleDateToMoment"
      [formatDateToTimestamp]="formatDateToTimestamp"
    ></tablesready-statistics>

    <div *ngIf="servicesSettings?.enabled && resourcesSettings?.enabled">
      <tablesready-services-and-resources-statistics
        #servicesResourcesStatisticsComponent
        [fromDate]="fromDate"
        [toDate]="toDate"
        [labels]="labels"
        [serviceLabel]="serviceLabel"
        [resourceLabel]="resourceLabel"
        [statistics]="analytics?.servicesResourcesStatistics || []"
        [servicesResourcesRadioItems]="servicesResourcesRadioItems"
        [timezone]="timezone"
        [loadTodayStats]="loadTodayStats"
        [simpleDateToMoment]="simpleDateToMoment"
        [formatDateToTimestamp]="formatDateToTimestamp"
      ></tablesready-services-and-resources-statistics>
    </div>

    <h1>
      Stats by Week - Last {{weeksToGoBack}} Weeks
    </h1>

    <common-radio-group
      *ngIf="userName"
      [items]="weeklyRadioItems"
      [(ngModel)]="weeklyChartType"
      (ngModelChange)="updateWeeklyPlot(weeklyChartType)"
      [minButtonWidthPx]="150"
      uncheckedButtonClass="btn-info"
      checkedButtonClass="btn-info"
      groupId="weekly-group"
      width="100%"
    ></common-radio-group>

    <div class="pt-3 col-xl-12 chart-canvas"><canvas #weeklyChartRef></canvas></div>

    <div class="pt-5">
      <h1>
        Stats by Day of Week - Last {{weeksToGoBack}} Weeks
      </h1>
    </div>

    <common-radio-group
      *ngIf="userName"
      [items]="dailyRadioItems"
      [(ngModel)]="dailyChartType"
      (ngModelChange)="updateDailyPlot(dailyChartType)"
      [minButtonWidthPx]="150"
      uncheckedButtonClass="btn-info"
      checkedButtonClass="btn-info"
      groupId="daily-group"
      width="100%"
    ></common-radio-group>

    <div class="pt-3 col-xl-12 chart-canvas"><canvas #dailyChartRef></canvas></div>

    <div class="pt-5">
      <h1>
        Stats by Half-Hour by Day - Last {{weeksToGoBack}} Weeks
      </h1>
    </div>
    <div *ngIf="userName" class="d-flex flex-column">
      <common-radio-group
        [items]="hourlyRadioItems"
        [(ngModel)]="hourlyChartType"
        (ngModelChange)="updateHourlyPlot(hourlyChartType, hourlyDOW)"
        [minButtonWidthPx]="150"
        uncheckedButtonClass="btn-info"
        checkedButtonClass="btn-info"
        groupId="hourly-group"
        width="100%"
      ></common-radio-group>

      <common-radio-group
        [items]="daysRadioItems"
        [(ngModel)]="hourlyDOW"
        (ngModelChange)="updateHourlyPlot(hourlyChartType, hourlyDOW)"
        [minButtonWidthPx]="150"
        uncheckedButtonClass="btn-secondary"
        checkedButtonClass="btn-secondary"
        groupId="hourly-day-group"
        width="100%"
      ></common-radio-group>
    </div>
    <div class="pt-3 col-xl-12 chart-canvas"><canvas #hourlyChartRef></canvas></div>
  </div>
</ion-content>
